import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 21 21",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="m4.359 16.042 3.541-.834 8.291-8.29a.833.833 0 0 0 0-1.18l-1.53-1.529a.833.833 0 0 0-1.178 0L5.193 12.5l-.834 3.542Zm7.727-10.176 2.5 2.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />' }
  })
);